import React from "react";

const getAttachmentUrl = (message) => message?.fileUrl || message?.text || "";

const MessageAttachment = ({ message, isSent = false }) => {
  const url = getAttachmentUrl(message);
  if (!url) return null;

  const fileName = message?.fileName || "Document";
  const isImage = message?.type === "image";
  const linkColor = isSent ? "#cce0ff" : "#025FEB";
  const labelColor = isSent ? "rgba(255,255,255,0.9)" : "#555";

  if (isImage) {
    return (
      <div className="message-attachment message-attachment--image">
        <div className="message-attachment-label" style={{ color: labelColor }}>
          Photo
        </div>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="message-attachment-image-link"
        >
          <img
            src={url}
            alt="Photo"
            className="message-attachment-image"
          />
        </a>
      </div>
    );
  }

  return (
    <div className="message-attachment message-attachment--file">
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="message-attachment-file-link"
        style={{ color: linkColor }}
      >
        {fileName}
      </a>
    </div>
  );
};

export default MessageAttachment;
